import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './literallycanvas.css';
// import App from './App';
import Toolbox from './container/toolbox';
import StickyNote from "./container/notes";
import NotePopup from "./container/notepopup";
import { Provider } from 'react-redux';
import store from './store';
import "./scss/style.scss"
//import reportWebVitals from './reportWebVitals';
let troot = '';
let noteroot = '', notepopup = '';
const AppStart = (props) => {
  if (troot != '') troot.unmount()
  troot = ReactDOM.createRoot(document.getElementById((props && props.toolbox) || "troot"));
  if (notepopup != '') notepopup.unmount()
  notepopup = ReactDOM.createRoot(document.getElementById("notepopuproot"));
  if (noteroot != '') noteroot.unmount()
  noteroot = ReactDOM.createRoot(document.getElementById("noteroot"));

  troot.render(
    <Provider store={store}>
      <Toolbox key={props.random} closeCallback={props.closeCallback} canvasObj={props.canvasObj} canvas={(props && props.canvas) || "croot"}
      focmode={props.focmode}
      />
    </Provider>
  );
  noteroot.render(
    <Provider store={store}>
      <StickyNote key={props.random} canvasObj={props.canvasObj} focmode={props.focmode}/>
    </Provider>)
  notepopup.render(
    <Provider store={store}>
      <NotePopup key={props.random}></NotePopup>
    </Provider>)
}

//  AppStart() //comment while integration with reader
window.AppStart = AppStart

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
//reportWebVitals();
